import { defineStore } from "pinia";

export const useLoadingStore = defineStore("loading", () => {
  const loading = ref(false);
  /**
   *
   * @param {boolean} value
   */
  function setLoading(value) {
    loading.value = value;
  }
  return { loading, setLoading };
});
